<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">部門管理</div>
      </md-card-header>

      <md-card-content>
        <router-link
          :to="{name: 'BackendUserDepartments'}">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </router-link>
      </md-card-content>

      <loading-spinner v-if="loadDetail"></loading-spinner>
      <md-card-content v-else-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          <form @submit.prevent="onSubmit" novalidate>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>部門情報</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('name')">
                    <label>部門名</label>
                    <md-input name="name" required v-model="form.name" :disabled="sending"/>
                    <span class="md-helper-text">例) 営業部</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('name')">{{ getValidationResponseMessage('name') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.name.required">{{ errors.name.required }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="$props.id === null">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('gmo_member_id')" tag="md-select">
                    <label>支払情報の名称を選択してください</label>
                    <md-select :disabled="sending" required v-model="form.gmo_member_id">
                      <md-option :key="'payment-method-' + paymentMethod.gmo_member_id"
                                 :value="paymentMethod.gmo_member_id"
                                 v-for="paymentMethod in paymentMethods">{{ paymentMethod.label }}
                      </md-option>
                    </md-select>
                    <span class="md-helper-text">※ 設定した翌月のお支払いから適用が可能です</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('gmo_member_id')">{{ getValidationResponseMessage('gmo_member_id') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.gmo_member_id.required">{{ errors.gmo_member_id.required }}</span>
                  </md-field>
                </div>
              </div>
            </md-card-content>

            <md-card-actions>
              <div class="md-layout md-layout-item md-alignment-center">
                <md-button class="md-raised md-primary" type="submit" :disabled="sending">
                  <md-icon>save</md-icon>
                  <span>登録する</span>
                </md-button>
              </div>
            </md-card-actions>
          </form>
        </div>
      </div>
    </md-card>
  </main>
</template>

<script>
  import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
  import CommonMixin                                    from '../../../mixins/commonMixin';
  import Validation                                     from '../../../modules/validation';
  import {validationMixin}                              from 'vuelidate';
  import {required, requiredIf}                         from 'vuelidate/lib/validators'
  import FlashMessage                                   from '../../../components/FlashMessage';
  import Common                                         from '../../../modules/common';
  import LoadingSpinner                                 from '../../../components/LoadingSpinner';
  import axios                                          from 'axios';

  export default {
    name      : "UserDepartmentNew",
    components: {LoadingSpinner, FlashMessage},
    props     : {
      id: {
        type   : String,
        default: null,
      }
    },
    mixins    : [CommonMixin, validationMixin],
    data() {
      return {
        groupId       : null,
        paymentMethods: [],
        form          : {
          name         : null,
          gmo_member_id: null,
        },
        errors        : {
          name         : {
            required: Validation.errorMessage(Validation.rules.required, 'groupName'),
          },
          gmo_member_id: {
            required: Validation.errorMessage(Validation.rules.required, 'gmoMemberId'),
          },
        },
        loadDetail    : false,
      }
    },
    validations() {
      return {
        form: {
          name         : {
            required,
          },
          gmo_member_id: {
            required: requiredIf(function () {
              return this.$props.id === null;
            }),
          },
        },
      };
    },
    mounted() {
      if (this.$props.id) {
        this.groupId = this.$props.id;
        this.getGroupDetail();
      } else {
        this.initDisplay();
        this.fetchDetail = true;
      }
    },
    methods   : {
      errorNotFound() {
        if (this.$props.id) {
          if (!this.groupId) {
            this.errorMessages = [Common.messages.group.notFound];
            return true;
          }
        }
        return false;
      },
      getGroupDetail() {
        const self          = this;
        this.successMessage = null;
        this.loadDetail     = true;
        const detailUrl     = apiList.jon.groups.detail.replace(':group_id', self.groupId);
        this.groupId        = null;
        apiClient.get(detailUrl)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            // detail information
            self.groupId   = response.data.group.id;
            self.form.name = response.data.group.name;
          })
          .catch(error => {
            self.errorMessages = [error.message];
          })
          .finally(() => {
            self.loadDetail  = false;
            self.fetchDetail = true;
            self.initDisplay();
          });
      },
      initDisplay() {
        if (this.$props.id !== null) {
          return;
        }
        this.loadingSpinner = true;
        this.sending        = true;
        const self          = this;
        let urls            = [];
        urls.push(apiClient.get(apiList.payment.payment_methods.list));
        axios
          .all(urls)
          .then(axios.spread((...responses) => {
            const paymentListResponse = responses[0];
            if (paymentListResponse !== undefined && self.hasResponseErrors(paymentListResponse)) {
              return;
            }

            if (paymentListResponse !== undefined) {
              // Get list of payments
              self.paymentMethods = paymentListResponse.data.data;
              self.paymentMethods.forEach(paymentMethod => {
                if (paymentMethod.gmo_member_id === self.form.gmo_member_id) {
                  this.paymentMethod = paymentMethod;
                }
              });
            }
          }))
          .catch(error => {
            self.errorMessages = [error.message];
          })
          .finally(() => {
            self.sending = false;
          });
      },
      onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          if (this.groupId) {
            this.updateGroup();
          } else {
            this.registerGroup();
          }
        }
      },
      createFormData() {
        let params = {
          'name': this.form.name,
        };
        if (this.$props.id == null) {
          params = Object.assign(params, {
            'gmo_member_id': this.form.gmo_member_id,
          });
        }
        return params;
      },
      registerGroup() {
        this.sending = true;
        apiClient.post(apiList.jon.groups.register, this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.setSnackBar(Common.messages.group.registrySuccess);
            this.$router.replace({name: 'BackendUserDepartments'});
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      updateGroup() {
        this.sending = true;
        apiClient.put(apiList.jon.groups.update.replace(':group_id', this.groupId), this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.setSnackBar(Common.messages.group.updateSuccess);
            this.$router.replace({name: 'BackendUserDepartments'});
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
